import { adapi } from '~';

export default {
  props: {
    kind: String,
    modelKey: [String, Number],
    notification: String,
    wide: Boolean,
  },
  data() {
    return {
      sending: false,
    };
  },
  computed: {
    route() {
      if (this.kind === 'creative') {
        return `creatives/${this.modelKey}/trigger-notification`;
      }
      return `campaigns/${this.modelKey}/trigger-notification`;
    },
  },
  methods: {
    trigger() {
      if (this.sending) {
        return;
      }

      this.sending = true;
      const fin = success => {
        this.sending = false;
        this.$emit('after', success);
      };

      adapi.post(this.route, null, { code: this.notification })
        .then(() => this.$toast.success({ message: this.$t('pos.campaign.notification-triggered') }))
        .then(() => fin(true))
        .catch(error => {
          this.$toast.error({ message: error.toString() });
          fin(false);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/trigger-notification/TriggerNotification.js